import AgentAPI from './agent.api'

export default AgentAPI
